import React from "react";
import Logo from "../assets/images/logos/vyqdabills.png";
const AppLogo = () => {
  return <img src={Logo} alt="applogo" className="app-logo" />;
};

export default AppLogo;
